import { render, staticRenderFns } from "./CustomerGroupUpdated.vue?vue&type=template&id=28de6e6e&scoped=true"
import script from "./CustomerGroupUpdated.vue?vue&type=script&lang=js"
export * from "./CustomerGroupUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28de6e6e",
  null
  
)

export default component.exports